import React, { useState } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { CustomButton } from '../../Infra/CustomButton/CustomButton';
import { CustomAutocomplete } from '../../Infra/CustomAutocomplete/CustomAutocomplete';
import { CURRENCIES, getCurrencyDisplay, Currency } from './currencyData';

interface CurrencySelectorProps {
  onAddCurrency: (currencyCode: string) => void;
  existingCurrencies: string[];
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  onAddCurrency,
  existingCurrencies,
}) => {
  const [selectedCurrency, setSelectedCurrency] = useState<Currency | null>(
    null
  );

  // Filter out currencies that already exist
  const availableCurrencies = CURRENCIES.filter(
    currency => !existingCurrencies.includes(currency.name)
  );

  const handleAdd = () => {
    if (selectedCurrency) {
      onAddCurrency(selectedCurrency.name);
      setSelectedCurrency(null);
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: 'grey.50',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'grey.300',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
        Add Additional Currency
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        <CustomAutocomplete
          value={selectedCurrency}
          onChange={(_, newValue) => setSelectedCurrency(newValue)}
          options={availableCurrencies}
          getOptionLabel={option => getCurrencyDisplay(option)}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              <Box
                sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
              >
                <Typography sx={{ fontWeight: 600, mr: 1 }}>
                  {option.name}
                </Typography>
                <Typography color="text.secondary">{option.symbol}</Typography>
              </Box>
            </Box>
          )}
          placeholder="Search and select currency..."
          textFieldProps={{ sx: { minWidth: 300 } }}
          sx={{ flex: 1 }}
        />
        <CustomButton
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAdd}
          disabled={!selectedCurrency}
          size="small"
        >
          Add
        </CustomButton>
      </Stack>
    </Box>
  );
};

export default CurrencySelector;
